<template>
  <div>
    <div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <b-row class="mt-4">
          <b-col>
            <label>Name on Gift Card or Voucher</label>
            <b-form-select
              id="select-passenger"
              v-model="$v.form.passenger.$model"
              v-bind="{ passenger }"
              :state="validateState('passenger')"
            >
              <option :value="null">Please Select Name...</option>
              <option
                v-for="(item, index) in travellingNames"
                :key="index"
                :value="item"
              >
                {{ item.name }}
              </option>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label>Email</label>
            <b-form-input
              id="email"
              v-model.trim="$v.form.email.$model"
              type="text"
              v-bind="{ passenger }"
              class="mb-2"
              :state="validateState('email')"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label>Preferred Contact Number</label>
            <b-form-input
              id="input-tel1"
              v-model.trim="form.tel1"
              v-bind="{ passenger }"
              type="text"
              class="mb-2"
            />
          </b-col>
        </b-row>
        <b-row  class="mt-2">
          <b-col>
            <b-form-group
              v-slot="{ ariaDescribedby }"
              label="Select:"
            >
              <b-form-radio-group
                id="radio-query-category"
                v-model="form.category"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="radio-query-category"
                stacked
                required
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row  class="mt-2">
          <b-col>
            <b-form-group
              label="Gift Card or Voucher Number:"
            >
              <b-form-input
                id="voucher-input"
                v-model="form.voucherNumber"
                type="text"
                placeholder="Please enter the XXXX number on your Gift Card or Voucher"
                required
                :state="validateState('voucherNumber')"
              />
              <b-form-invalid-feedback v-if="!$v.form.voucherNumber.required">
                Please enter
                {{ form.category === 'Voucher' ? 'the 6-digit alphanumeric' : 'a 16-digit' }}
                {{ form.category }} Code
              </b-form-invalid-feedback>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label>Amount</label>
            <b-form-input
                id="payment-input"
                v-model="form.amount"
                type="number"
                required
                :state="validateState('amount')"
                :disabled="agreedToIssueFlights"
              />
          </b-col>
        </b-row>
        <b-row class="flex-row">
            <b-button
            :disabled="disabled"
            type="submit"
            class="ml-lg-3 address-block-btn address-btn-submit justify-content-center"
            >
            <span>Submit</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
            </b-button>
        </b-row>
      </b-form>
      <b-row v-if="sendingError">
        <b-col>
          <b-alert variant="danger" class="text-center" show>
            Failed to send Email. 
            Please make sure all the information above is correct and try again.
          </b-alert>
        </b-col>
      </b-row>
    </div>
    <confirmationComponent ref="voucher-confirmation-ref"/>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { isOfficeOpen, sendRedeemConfirmationEmail } from "../services";
import { mapGetters } from "vuex";
import confirmationComponent from './confirmationVoucherModal'

export default {
  components: {
    confirmationComponent
  },
  props: {
    booking: {
      type: Object,
      default: null,
    },
    loadRedeemVoucher: {
      type: Function,
      required: true,
    },
    travellingNames : {
      type: Array,
      default: null
    },
    agreedToIssueFlights: {
      type: Boolean,
      default: false,
    },
    fullBalanceAmount: {
      type: String,
    }
  },
  data() {
    return {
      disabled: false,
      options: [
        { text: "Travel Voucher", value: "Voucher" },
        { text: "Gift Card", value: "Gift Card" }
      ],
      form: {
        passenger: null,
        email: this.email,
        tel1: "",
        tel2: "",
        tel3: "",
        amount: null,
        voucherNumber: "",
        category: "",
        isOfficeOpen: true,
        country: ''
      },
      sendingError: false
    };
  },
  validations: {
    form: {
      email: {
        required,
      },
      passenger: {
        name: {
          required,
        },
      },
      voucherNumber: {
        required(value){
          if(this.form.category === "Voucher"){
             const voucherValidation =  /^[A-Za-z0-9]{6}$/.test(value);
             return voucherValidation
           } else if(this.form.category === "Gift Card"){
              const cardValidation =  /^[0-9]{16}$/.test(value);
              return cardValidation
          }else{
            return false;
          }
        }
      },
      amount:{
        required(value) {
        if (value === null || value === 0) {
          return false;
        }
        return true; 
      },
      },
      
    },
  },
  computed: {
    ...mapGetters({
      email: "booking/getEmail",
      tel1: "booking/getTel1",
      tel2: "booking/getTel2",
      tel3: "booking/getTel3",
      bookingData: "booking/getBooking",
      bookingNo: "booking/getBookingNumber",
      paxNames: "booking/getBookingPassengers",
      getCountry: "booking/getCountry"
    }),
    passenger() {
      return this.form.passenger;
    },
  },
  watch: {
    // whenever passenger changes, this function will run
    passenger() {
      if (this.passenger !== null) {
        this.form.tel1 = this.passenger.tel;
        this.form.tel2 = this.tel2;
        this.form.tel3 = this.tel3;
        this.form.email = this.passenger.email;
      }
    }
  },
  mounted(){
    if (this.agreedToIssueFlights) {
      this.form.amount = Number(this.fullBalanceAmount)
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    show() {
      this.$bvModal["voucher-confirmation-ref"].show();
    },
    async onSubmit() {
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 5000);
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let officeDetails = await isOfficeOpen();
      this.form.isOfficeOpen = officeDetails.officeOpen;
      this.form.country = this.getCountry;
      const emailData = {
        bookingNumber: this.bookingNo.toUpperCase(),
        sendEmailTo: this.emailBranch(this.isOfficeOpen),
        passenger: this.form.passenger,
        formData: {
          passengerName: this.form.passenger.name,
          inputEmail: this.form.email,
          inputTel: this.form.tel1,
          category: this.form.category,
          voucherNumber: this.form.voucherNumber,
          amount: this.form.amount,
          country: this.form.country
        }
      }
      const res = await sendRedeemConfirmationEmail(emailData)
      if(res.emailStatus === "Success") {
        this.loadRedeemVoucher();
        this.resetForm()
        this.$refs["voucher-confirmation-ref"].showModal();
        setTimeout(() => {
          this.$refs["voucher-confirmation-ref"].closeModal();
        }, 4000);
      } else {
        this.sendingError = true
        setTimeout(() => {
          this.sendingError = false
        }, 3500);
      }
    },
    emailBranch(isOfficeOpen){
        const branch = this.bookingData.booking_information.branch;
        const contactbranch = this.bookingData.booking_information.contact_branch;
        let emailto = "";

        if (isOfficeOpen) {
          emailto = "nightduty@trailfinders.com";
        } else if (branch === "DUB" && contactbranch === "ork") {
          emailto = "ork@trailfinders.com";
        } else if (branch === "DUB" && contactbranch === "lmk") {
          emailto = "lmk@trailfinders.com";
        } else {
          emailto = "etrailquestions@trailfinders.com";
        }
        return emailto;
    },
    resetForm() {
      this.$v.$reset(); 
      this.form =  {
        passenger: null,
        email: '',
        tel1: "",
        tel2: "",
        tel3: "",
        amount: null,
        voucherNumber: "",
        category: "",
        isOfficeOpen: null,
      }
    }
  }
};
</script>

